import { useTranslation } from 'react-i18next'

import { ApiError } from '@/api/problemDetails'

/** Texto humano para cada `errorCode` de cobrança (`04` §3); nunca o título técnico. */
export function useBillingErrorText() {
  const { t } = useTranslation()
  return (error: unknown): string => {
    const code = error instanceof ApiError ? error.problem.errorCode : undefined
    const known = t('billing.errors', { returnObjects: true }) as Record<string, string>
    return code !== undefined && known[code] !== undefined
      ? known[code]
      : t('billing.errors.generic')
  }
}
